"use strict";

/* eslint-disable */
if (typeof AbortController === 'undefined') {
  var _require = require('abortcontroller-polyfill/dist/cjs-ponyfill'),
      _AbortController = _require.AbortController,
      _AbortSignal = _require.AbortSignal;

  module.exports = {
    AbortController: _AbortController,
    AbortSignal: _AbortSignal
  };
} else {
  module.exports = {
    AbortController: AbortController,
    AbortSignal: AbortSignal
  };
}